import { render } from "./ContractBreakdown.vue?vue&type=template&id=56f58ede&scoped=true"
import script from "./ContractBreakdown.vue?vue&type=script&lang=js"
export * from "./ContractBreakdown.vue?vue&type=script&lang=js"

import "./ContractBreakdown.vue?vue&type=style&index=0&id=56f58ede&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\860\\s\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f58ede"]])

export default __exports__